import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-cards-reusable',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cards-reusable.html',
  styleUrl: './cards-reusable.css'
})
export class CardsReusable {
  @Input() title = 'Card title';
  @Input() subtitle = '';
  @Input() badge = '';
  @Input() actionLabel = '';

  @Output() action = new EventEmitter<void>();

  onAction(): void {
    this.action.emit();
  }
}
